import { render, staticRenderFns } from "./duibifenxiangbiao.vue?vue&type=template&id=5a81d9ff&scoped=true&"
import script from "./duibifenxiangbiao.vue?vue&type=script&lang=js&"
export * from "./duibifenxiangbiao.vue?vue&type=script&lang=js&"
import style0 from "./duibifenxiangbiao.vue?vue&type=style&index=0&id=5a81d9ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a81d9ff",
  null
  
)

export default component.exports